import { render, staticRenderFns } from "./contractArchive.vue?vue&type=template&id=f587f1b6"
import script from "./contractArchive.vue?vue&type=script&lang=js"
export * from "./contractArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports